import { render } from "./SocialBanner.vue?vue&type=template&id=f6d1c99e"
import script from "./SocialBanner.vue?vue&type=script&lang=js"
export * from "./SocialBanner.vue?vue&type=script&lang=js"

import "./SocialBanner.vue?vue&type=style&index=0&id=f6d1c99e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__